import type { Locale } from '@/types'
import type { Dictionary } from '@/constants/content/en'

import { useRouter } from 'next/router'
import { en } from '@/constants/content/en'
import { zhTw } from '@/constants/content/zh-tw'

// The active locales live in the i18n block of next.config.ts. Add a dictionary here for each one.
const DICTIONARIES: Record<Locale, Dictionary> = {
    'en': en,
    'zh-tw': zhTw
}

const FALLBACK_LOCALE: Locale = 'en'

export const LANGUAGE_OPTIONS: Array<{ locale: Locale, label: string, lang: string }> = [
    { locale: 'en', label: 'EN', lang: 'en' },
    { locale: 'zh-tw', label: '繁中', lang: 'zh-Hant-TW' }
]

export const isLocale = (value: unknown): value is Locale => {
    return typeof value === 'string' && Object.prototype.hasOwnProperty.call(DICTIONARIES, value)
}

export const getDictionary = (locale: unknown): Dictionary => {
    return DICTIONARIES[isLocale(locale) ? locale : FALLBACK_LOCALE]
}

export const useLocale = (): Locale => {
    const { locale } = useRouter()

    return isLocale(locale) ? locale : FALLBACK_LOCALE
}

export const useDictionary = (): Dictionary => {
    return DICTIONARIES[useLocale()]
}
